export const NAME = 'identityVerification';
